import React, { useEffect, useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import mark from '../../images/evolve-mark.png';
import './LabNav.scss';

// `to` = in-page section, `href` = a real navigation out of this app.
// Evolved UI is a separate static app served at /ui, so it must be a plain
// anchor — a router link would be handled client-side and never load it.
const NAV = [
    { label: 'Products', to: 'products' },
    { label: 'Lab', to: 'lab' },
    { label: 'Evolved UI', href: '/ui/' },
    { label: 'Technology', to: 'stack' },
    { label: 'About', to: 'about' },
];

const LabNav = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    // Lock the page while the mobile sheet is open.
    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);

    return (
        <header className={`lab-nav ${scrolled ? 'is-scrolled' : ''}`}>
            <div className="lab-nav-inner">
                <ScrollLink to="hero" smooth duration={600} className="lab-wordmark">
                    <img src={mark} alt="Evolve Labs" className="lab-wordmark-mark" />
                    <span className="lab-wordmark-text">
                        EVOLVE<span className="lab-wordmark-labs">LABS</span>
                    </span>
                </ScrollLink>

                <nav className="lab-nav-links">
                    {NAV.map(({ label, to, href }) =>
                        href ? (
                            <a key={href} href={href} className="lab-nav-link">
                                {label}
                            </a>
                        ) : (
                            <ScrollLink
                                key={to}
                                to={to}
                                smooth
                                duration={600}
                                offset={-80}
                                spy
                                activeClass="is-active"
                                className="lab-nav-link"
                            >
                                {label}
                            </ScrollLink>
                        ),
                    )}
                </nav>

                <ScrollLink
                    to="products"
                    smooth
                    duration={600}
                    offset={-80}
                    className="lab-nav-cta"
                >
                    View Products <span aria-hidden="true">→</span>
                </ScrollLink>

                <button
                    type="button"
                    className={`lab-nav-burger ${open ? 'is-open' : ''}`}
                    onClick={() => setOpen((v) => !v)}
                    aria-label={open ? 'Close menu' : 'Open menu'}
                    aria-expanded={open}
                >
                    <span />
                    <span />
                </button>
            </div>

            <div className={`lab-sheet ${open ? 'is-open' : ''}`}>
                {NAV.map(({ label, to, href }, i) => {
                    const inner = (
                        <>
                            <span className="lab-sheet-index">0{i + 1}</span>
                            {label}
                        </>
                    );
                    return href ? (
                        <a
                            key={href}
                            href={href}
                            className="lab-sheet-link"
                            style={{ '--i': i }}
                            onClick={() => setOpen(false)}
                        >
                            {inner}
                        </a>
                    ) : (
                        <ScrollLink
                            key={to}
                            to={to}
                            smooth
                            duration={600}
                            offset={-70}
                            className="lab-sheet-link"
                            style={{ '--i': i }}
                            onClick={() => setOpen(false)}
                        >
                            {inner}
                        </ScrollLink>
                    );
                })}
            </div>
        </header>
    );
};

export default LabNav;
